import React, { useState } from 'react';
import DTOCompOffARModal from './DTOCompOffARModal';
import { useTranslation } from 'react-i18next';
import { actionRequiredService } from '../../../../api/services/actionRequiredService';
import { useAppSelector } from '../../../../infra/hooks';
import toast from 'react-hot-toast';
import CompOffARModalPresenter from './CompOffARModalPresenter';

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;

  fullData?: any;
}

const CompOffARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
}: ModalInterface) => {
  const [daActions, setDaActions] = useState([]);
  const { t } = useTranslation();
  const selector = useAppSelector((state) => state.authSlice);

  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == 'success') {
          toast.success('Action Performed Successfully!');
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOCompOffARModal setAllActions={(act: any) => setDaActions(act)} />

      <CompOffARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        allActions={daActions}
        fullData={fullData}
        userId={selector.user_id}
        handleSubmitAR_Request={hitAction}
      />
    </div>
  );
};

export default CompOffARModalController;
